import type { AvailableProviders } from '@/utils/constants/providers/availableProviders'
import { trackHeapEvent } from '../../trackHeapEvent'

export enum LinkedLocationProfilesHeapEvents {
  link = 'location-details-linked-location-profiles-link',
  unlink = 'location-details-linked-location-profiles-unlink',
  connect = 'location-details-linked-location-profiles-connect',
}
interface LinkedLocationProfilesCommonProps {
  provider: AvailableProviders
}

interface LinkedLocationProfilesConnectProps extends LinkedLocationProfilesCommonProps {
  status: 'Success' | 'Fail'
}

interface LinkedLocationProfilesUnlinkProps {
  status: 'Success' | 'Fail'
  provider?: AvailableProviders
}

export const linkedLocationProfilesTrackingEvents = {
  link({ provider }: LinkedLocationProfilesCommonProps) {
    trackHeapEvent(LinkedLocationProfilesHeapEvents.link, {
      provider,
    })
  },

  unlink({ provider, status }: LinkedLocationProfilesUnlinkProps) {
    trackHeapEvent(LinkedLocationProfilesHeapEvents.unlink, {
      provider,
      status,
    })
  },

  connect({ provider, status }: LinkedLocationProfilesConnectProps) {
    trackHeapEvent(LinkedLocationProfilesHeapEvents.connect, {
      provider,
      status,
    })
  },
}
